<section class="panel widget-container flex-container">
  <header class="panel-heading">
    <ng-container *ngIf="title">
      <div class="widget-title">
        <h5 class="panel-title">{{title}}</h5>
      </div>
    </ng-container>
    <ng-container *ngIf="isDashboardDesignerMode">
      <div class="widget-control">
        <a (click)="dashboardDesignerDelete()" class="btn active" title="Remove Widget"><span
            class="fa fa-times"></span></a>
      </div>
    </ng-container>
    <ng-container *ngIf="showWidgetControls && !isDashboardDesignerMode">
      <div class="widget-control">
        <ng-content select="[widget-control-section]"></ng-content>
        <ng-container *ngIf="allowMaximise">
          <a alt="Maximise Widget" *ngIf="(maximisedWidget$ |async) == undefined" (click)="maximise()"
            class="btn active" title="Show Full Screen"><span class="fa fa-expand fa-lg"></span></a>
          <a alt="Minimise Widget" *ngIf="(maximisedWidget$ |async) != undefined" (click)="restore()"
            class="btn active" title="Normal Size"><span class="fa fa-compress fa-lg"></span></a>
        </ng-container>
        <ng-container *ngIf="allowDelete">
          <a alt="Delete Widget" (click)="delete()" class="btn active" title="Remove Widget"><span class="fa fa-times fa-lg"></span></a>
        </ng-container>
      </div>
    </ng-container>
  </header>

  <ng-content select="[widget-body]"></ng-content>

</section>
